module.exports = new __parcel__URL__("troops_healer.498521f1.png").toString();